import React, { useId } from "react";
import { FiArrowDown, FiArrowLeft, FiPlay, FiRefreshCw } from "react-icons/fi";
import "../styles/hrmRoninLaunch.css";

const RONIN_ARTWORK = "/assets/ronin/village-art.webp";

const HrmRoninLaunch = ({ onPlay, checking = false, error = "", onRetry }) => {
  const id = useId();
  const titleId = `ronin-title-${id}`;
  const trailerId = `ronin-trailer-${id}`;
  const trailerTitleId = `ronin-trailer-title-${id}`;

  return (
    <div className="hrm-ronin-launch">
      <header className="hrm-ronin-launch__header">
        <div className="hrm-ronin-launch__inner hrm-ronin-launch__header-inner">
          <img
            className="hrm-ronin-launch__logo"
            src="/assets/ronin/antrazal-white-r2.svg"
            alt="Antrazal"
            width="2048"
            height="609"
          />
          <a className="hrm-ronin-launch__back" href="/HRM">
            <FiArrowLeft aria-hidden="true" />
            HRM
          </a>
        </div>
      </header>

      <section className="hrm-ronin-launch__hero" aria-labelledby={titleId}>
        <img
          className="hrm-ronin-launch__poster"
          src={RONIN_ARTWORK}
          alt="Ronin village artwork"
          width="1024"
          height="1010"
        />
        <div className="hrm-ronin-launch__overlay">
          <div className="hrm-ronin-launch__inner">
            <h1 className="hrm-ronin-launch__title" id={titleId}>Ronin</h1>
            <p className="hrm-ronin-launch__copy">A game by Antrazal.</p>
            <div className="hrm-ronin-launch__actions">
              <button
                className="hrm-ronin-launch__play"
                type="button"
                onClick={onPlay}
                disabled={checking}
                aria-busy={checking}
              >
                <FiPlay aria-hidden="true" />
                Play game
              </button>
              <a className="hrm-ronin-launch__watch" href={`#${trailerId}`}>
                Watch trailer
                <FiArrowDown aria-hidden="true" />
              </a>
            </div>
            <p className="hrm-ronin-launch__status" role="status">
              {checking ? "Preparing Ronin..." : ""}
            </p>
            {error && (
              <div className="hrm-ronin-launch__error">
                <p role="alert">{error}</p>
                <button
                  className="hrm-ronin-launch__retry"
                  type="button"
                  onClick={onRetry}
                  disabled={checking}
                >
                  <FiRefreshCw aria-hidden="true" />
                  Retry
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      <section
        className="hrm-ronin-launch__trailer"
        id={trailerId}
        aria-labelledby={trailerTitleId}
        tabIndex={-1}
      >
        <div className="hrm-ronin-launch__inner">
          <h2 className="hrm-ronin-launch__trailer-title" id={trailerTitleId}>Trailer</h2>
          <video
            className="hrm-ronin-launch__video"
            aria-label="Ronin trailer"
            controls
            controlsList="nodownload"
            playsInline
            preload="none"
            poster={RONIN_ARTWORK}
            width="1920"
            height="1080"
          >
            <source src="/assets/ronin/ronin-trailer-720p.mp4" type="video/mp4" />
            <track
              kind="captions"
              src="/assets/ronin/trailer-captions.vtt"
              srcLang="en"
              label="English"
            />
            Your browser does not support embedded video.
          </video>
        </div>
      </section>
    </div>
  );
};

export default HrmRoninLaunch;
